<div class="terms-container">
  <p class="disclaimer-paragraph">
    Genom att fortsätta godkänner jag
    <a
      class="disclaimer-link"
      target="_blank"
      [href]="termsLinkService.getTermsLink()"
    >
      Zavers villkor
    </a>
    , samt bekräftar att jag läst Zavers
    <a
      class="disclaimer-link"
      target="_blank"
      [href]="termsLinkService.getPrivacyPolicyLink()"
    >
      Integritetspolicy
    </a>
    och
    <a
      class="disclaimer-link"
      target="_blank"
      [href]="termsLinkService.getCookiePolicyLink()"
    >
      Cookiepolicy
    </a>
    , samt accepterar betalningsansvar.
    <a
      class="disclaimer-link"
      target="_blank"
      [href]="termsLinkService.getSekkiLink(paymentRequest)"
    >
      Visa&nbsp;SEKKI.
    </a>
  </p>
</div>
